<section class="form_section">
    <h2>Actualizar Estado</h2>
    <form action="" [formGroup]="formNuevaActividad" (ngSubmit)="submit()" class="form_register_minutes">
        <mat-form-field>
            <mat-label>Estado</mat-label>
            <select matNativeControl required formControlName="estado">
                <option value="" disabled selected>Seleccione</option>
                <option value="aprobado">Aprobado</option>
                <option value="rechazado">Rechazado</option>
                <option value="informacion">Requiere Informacion</option>
            </select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Comentario</mat-label>
            <textarea matInput formControlName="comentario" placeholder="Comentario"> </textarea>
        </mat-form-field>

        <button mat-stroked-button  color="primary" class="w-50" [disabled]="!formNuevaActividad.valid">
            Guardar
        </button>
    </form>
</section>
  